/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChartDataRange
 */
export interface ChartDataRange {
    /**
     * 
     * @type {number}
     * @memberof ChartDataRange
     */
    min?: number;
    /**
     * 
     * @type {number}
     * @memberof ChartDataRange
     */
    max?: number;
}

/**
 * Check if a given object implements the ChartDataRange interface.
 */
export function instanceOfChartDataRange(value: object): value is ChartDataRange {
    return true;
}

export function ChartDataRangeFromJSON(json: any): ChartDataRange {
    return ChartDataRangeFromJSONTyped(json, false);
}

export function ChartDataRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartDataRange {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'] == null ? undefined : json['min'],
        'max': json['max'] == null ? undefined : json['max'],
    };
}

export function ChartDataRangeToJSON(json: any): ChartDataRange {
    return ChartDataRangeToJSONTyped(json, false);
}

export function ChartDataRangeToJSONTyped(value?: ChartDataRange | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

